module.exports = __webpack_public_path__ + "b1db0d4bcf18dcc89c1c80d66412693a.jpg";